/* eslint-disable no-comments/disallowComments */
import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type RTitleSize = 'h1' | 'h2' | 'h3';

interface RTitleProps {
    children: React.ReactNode;
    /** Heading level — controls both the HTML element and the visual size. */
    size?: RTitleSize;
    className?: string;
}

const baseStyles = {
    fontWeight: 700,
    color: Colors.darkNavy,
    margin: 0,
};

const H1 = styled('h1')({ ...baseStyles, fontSize: 28 });
const H2 = styled('h2')({ ...baseStyles, fontSize: 18 });
const H3 = styled('h3')({ ...baseStyles, fontSize: 15, fontWeight: 500 });

const COMPONENTS: Record<RTitleSize, React.ElementType> = { h1: H1, h2: H2, h3: H3 };

export function RTitle({ children, size = 'h2', className }: RTitleProps) {
    const Component = COMPONENTS[size];
    return <Component className={className}>{children}</Component>;
}
/* eslint-enable no-comments/disallowComments */
